import React, { useState, useEffect } from "react";
import { Modal, Box, Typography, TextField, Select, MenuItem, Button, IconButton, Divider, InputLabel, FormControl, GlobalStyles, Tabs, Tab, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { useOutletContext, useSearchParams } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { Editor } from "@tinymce/tinymce-react";
import SingleSelectDropdown from "../../pages/SingleSelectDropdown";
import { parseCurl } from "../../Helpers/parseCurl";
import HeaderTable from "./HeaderTable";
import ApiBodyTable from "./ApiBodyTable";
import DeleteIcon from "@mui/icons-material/Delete";
import AddResponses from "./addResponses";
import { allIcons } from "../icons";
import { developerTollApi } from "../../services/developerTollApi";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  maxHeight: "90dvh",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "20px",
};


const AddEndpoint = (props) => {
  const {openEditor, handleClose, selectedEndpoint, allProducts, selectedProduct, setSelectedProduct, allTags, setSelectedTag, selectedTag, fetchAllTagEndpoint, editEndpoint} = props;
  const { open } = useOutletContext();
  const [product, setProduct] = useState("");
  const [tagName, setTagName] = useState("");
  const [endpointName, setEndpointName] = useState("");
  const [endpointDescription, setEndpointDescription] = useState("");
  const [endPointType, setEndPointType] = useState("");
  const [body, setBody] = useState("");
  const [method, setMethod] = useState("GET");
  const methods = ["GET", "POST", "PUT", "PATCH", "DELETE", "HEAD", "OPTIONS"];
  const [url, setUrl] = useState("");
  const [headers, setHeaders] = useState([{ key: "", value: "" }]);
  const [tabIndex, setTabIndex] = useState(0);
  const [bodyTab, setBodyTab] = useState(0);
  const [formDatas, setFormDatas] = useState([{ key: "", value: "", type: "" }]);
  const [jsonBody, setJsonBody] = useState("");
  const [loader, setLoader] = useState(false);
  const [openResponses, setOpenResponses] = useState(false);
  const [apiResponses, setApiResponses] = useState([]);
  const [selectedResponse, setSelectedResponse] = useState(null);
  const [authType, setAuthType] = useState("none");
  const [authValue, setAuthValue] = useState("");

  const typeOptions = [
    { label: "Public", value: "public" },
    { label: "Private", value: "private" },
  ];

  const handleHeaderChange = (index, field, value) => {
    setHeaders((prev) => {
      const updated = [...prev];
  
      if (!updated[index]) {
        updated[index] = { key: "", value: "" };
      }
  
      updated[index][field] = value;
      if (
        index === updated.length - 1 &&
        (updated[index].key || updated[index].value)
      ) {
        updated.push({ key: "", value: "" });
      }
  
      return updated;
    });
  };
  

  const handleFormDataChange = (index, field, value) => {
    setFormDatas((prev) => {
      const updated = [...prev];
      if (!updated[index]) {
        updated[index] = { key: "", value: "", type: "" };
      }
  
      updated[index][field] = value;
      if (
        index === updated.length - 1 &&
        (updated[index].key || updated[index].value)
      ) {
        updated.push({ key: "", value: "", type: "" });
      }
  
      return updated;
    });
  };
  
  
  const handleDelete = (index) => {
      const updated = headers.filter((_, i) => i !== index);
      setHeaders(updated);
  };

  const handleFormDataDelete = (index) => {
    const updated = formDatas.filter((_, i) => i !== index);
    setFormDatas(updated);
};

  useEffect(() => {
    if (selectedEndpoint && openEditor) {
      console.log(selectedEndpoint)
      setEndpointName(selectedEndpoint.endpoint_name || "");
      setEndpointDescription(selectedEndpoint.description || "");
      setUrl(selectedEndpoint.request?.url?.raw || "");
      setMethod(selectedEndpoint.request?.method || "GET");
      const allHeaders = selectedEndpoint.request?.header || [];
      const authHeader = allHeaders.find(h => h.authType);
      if (authHeader) {
        setAuthType(authHeader.authType);
        setAuthValue(authHeader.value.replace(/^Bearer\s|^Basic\s|^/, "")); 
      } else {
        setAuthType("noauth");
        setAuthValue("");
      }
      setHeaders(allHeaders.filter(h => !h.authType) || []);
      // setHeaders(selectedEndpoint.request?.header || []);

      if (selectedEndpoint.request?.body?.mode === "formdata") {
        setBodyTab(1);
        setFormDatas(selectedEndpoint.request.body.formdata || []);
      } else {
        setBodyTab(0);
        setJsonBody(selectedEndpoint.request?.body?.raw || "");
      }

      setApiResponses(selectedEndpoint.response || []);
      setEndPointType(selectedEndpoint.is_public ? "public" : "private");
      setBody(selectedEndpoint.documentation || "");
      // setSelectedTag(selectedEndpoint.tag_id || null);
    }
  }, [selectedEndpoint, openEditor]);

  const handleSave = async () => {
    console.log({ endpointName, endpointDescription, endPointType, product, body, method, url, headers, bodyTab, jsonBody, formDatas });
    const formData = new FormData();
    formData.append("endpoint_name", endpointName);
    formData.append("description", endpointDescription);
    formData.append("is_public", endPointType === "public" ? true : false);
    formData.append("documentation", body);

    let finalHeaders = headers.filter(h => h.key && h.value);

    if (authType === "bearer") {
      finalHeaders.push({ key: "Authorization", value: `Bearer ${authValue}`, authType: `bearer` });
    }
    if (authType === "basic") {
      finalHeaders.push({ key: "Authorization", value: `Basic ${btoa(authValue)}`, authType: `basic` });
    }
    if (authType === "apikey") {
      finalHeaders.push({ key: "x-api-key", value: authValue, authType: `apikey` });
    }

    const requestPayload = {
      url: {
        raw: url
      },
      method: method,
      header: finalHeaders,
      description: endpointDescription,
      body: {
        mode: bodyTab === 0 ? "raw" : "formdata",
        raw: bodyTab === 0 ? jsonBody : {},
        formdata: bodyTab === 1
          ? formDatas.filter(fd => fd.key).map(fd => ({
              key: fd.key,
              value: fd.value,
              type: fd.type || "text"
            }))
          : []
      }
    };

    formData.append("request", JSON.stringify(requestPayload));
    formData.append("responses", JSON.stringify(apiResponses));
    formData.append("tag_id", selectedTag);
    if(editEndpoint)
    {
      formData.append("endpoint_id", selectedEndpoint?.endpoint_id);
    }
    console.log(formData);
    setLoader(true);
    try {
      let response;
      if (editEndpoint && selectedEndpoint?.endpoint_id) {
        response = await developerTollApi.updateEndpoint(formData);
      } else {
        response = await developerTollApi.addEndpoint(formData);
      }
      console.log(response)
      if(response?.status)
      {
        handleClose();
        fetchAllTagEndpoint();
      }
    } catch (error) {
        console.error("Error fetching line chart data:", error);
    } finally {
        setLoader(false);
    }

  };

  useEffect(() => {
    const last = formDatas[formDatas.length - 1];
    if (last?.key || last?.value) {
      setFormDatas([...formDatas, { key: "", value: "" }]);
    }
  }, [formDatas]);
  
  console.log(apiResponses)
  return (<>
    <Box sx={{ flexGrow: 1, p: 3, width: open ? "calc(100% - 280px)" : "calc(100% - 100px)", marginLeft: open ? "280px" : "100px", transition: "margin 0.3s ease", height: "100vh", display: "flex", background: "#f9f9f9", }}>
      <Box mt={10} style={{ borderRadius: "12px", background: "#fff", width: "100%", height: "calc(100% - 76px)", marginLeft: open ? "" : "1em", }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" p="20px 30px">
          <Box sx={{ display: "flex", cursor: "pointer", gap: 2 }} onClick={handleClose} >
            <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 18L2 10L9 2" stroke="#1D1D1D" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <Typography sx={{ fontSize: '20px', fontWeight: 600, lineHeight: '20px', color: "#1D1D1D", paddingBottom: "2px" }}>Create Tag</Typography>
          </Box>
        </Box>

        <Divider />

        <Box sx={{ p: "20px 30px", overflow: "auto", maxHeight: "calc(100% - 168px)" }}>
          {/* <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2 }}>
            <SingleSelectDropdown
                label={<Box sx={{ display: "flex", gap: 1}}>Product</Box>}
                value={product}
                onChange={(val) => {setProduct(val); setSelectedProduct(val) }}
                options={allProducts.map(item => ({
                  label: item.product_name.replace(/_/g, " "),
                  value: item.product_id,
                }))}
                width="100%"
            />

            <SingleSelectDropdown
                label={<Box sx={{ display: "flex", gap: 1}}>Product Tag</Box>}
                value={tagName}
                onChange={(val) => setTagName(val)}
                options={allTags.map(item => ({
                  label: item.tag_name.replace(/_/g, " "),
                  value: item.tag_id,
                }))}
                width="100%"
            />
          </Box> */}
          <Box>
            <TextField
              variant="outlined"
              name="endpoint_name"
              label="Endpoint Name"
              type="text"
              value={endpointName}
              onChange={(e) => setEndpointName(e.target.value)}
              fullWidth
              InputLabelProps={{
                sx: {
                  fontSize: "16px",
                  transform: endpointName ? "translate(14px, -8px) scale(0.9)" : "translate(14px, 11px) scale(1)",
                  background: endpointName ? "FFFFFF" : "none",
                  color: "#6F6F6F",
                  "&.Mui-focused": {
                    color: endpointName ? "#1D1D1D" : "#6F6F6F",
                    transform: "translate(14px, -8px) scale(0.9)",
                  },
                },
              }}
              sx={{
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    "& fieldset": {
                      borderColor: "#DFDFDF",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#DFDFDF",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#DFDFDF",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                  
              }}
              InputProps={{
                  sx: { 
                      fontSize: "16px",
                      fontWeight: "500",
                      height: 45,
                      "& input::-ms-reveal, & input::-ms-clear": {
                          display: "none",
                      },
                      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                          display: "none",
                          WebkitAppearance: "none",
                          margin: 0,
                      },
                      "& input[type=number]": {
                          MozAppearance: "textfield",
                      },
                  },
              }}
            />
          </Box>
          <Box mt={2}>
            <TextField
              variant="outlined"
              name="description"
              label="Description"
              type="text"
              value={endpointDescription}
              onChange={(e) => setEndpointDescription(e.target.value)}
              fullWidth
              InputLabelProps={{
                sx: {
                  fontSize: "16px",
                  transform: endpointDescription ? "translate(14px, -8px) scale(0.9)" : "translate(14px, 11px) scale(1)",
                  background: endpointDescription ? "FFFFFF" : "none",
                  color: "#6F6F6F",
                  "&.Mui-focused": {
                    color: endpointDescription ? "#1D1D1D" : "#6F6F6F",
                    transform: "translate(14px, -8px) scale(0.9)",
                  },
                },
              }}
              sx={{
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    "& fieldset": {
                      borderColor: "#DFDFDF",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#DFDFDF",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#DFDFDF",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                  
              }}
              InputProps={{
                  sx: { 
                      fontSize: "16px",
                      fontWeight: "500",
                      height: 45,
                      "& input::-ms-reveal, & input::-ms-clear": {
                          display: "none",
                      },
                      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                          display: "none",
                          WebkitAppearance: "none",
                          margin: 0,
                      },
                      "& input[type=number]": {
                          MozAppearance: "textfield",
                      },
                  },
              }}
            />
          </Box>
          
          <SingleSelectDropdown
              label={<Box sx={{ display: "flex", gap: 1}}>Endpoint Type</Box>}
              value={endPointType}
              onChange={(val) => setEndPointType(val)}
              options={typeOptions}
              width="100%"
              sx={{ mt: 2}}
          />

          
          <Box sx={{ display: "flex", gap:1, alignItems: "center", justifyContent: "space-between", mt: 2, }}>
            <Box sx={{ display: "flex", gap: 1, alignItems: "center", background: "#fff", borderRadius: "8px", border : "1px solid #D9D9D9", width: "100%" }}>
                <TextField
                    select
                    variant="outlined"
                    fullWidth
                    value={method}
                    onChange={(e) => setMethod(e.target.value)}
                    sx={{
                        width: 150,
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        "& .MuiOutlinedInput-root": {
                        height: 46,
                        fontSize: "16px",
                        fontWeight: 500,
                        borderRadius: "10px",
                        backgroundColor: "#fff",
                        "& fieldset": {
                            border: "none", // ✅ completely removes border
                        },
                        "&:hover fieldset": {
                            border: "none",
                        },
                        "&.Mui-focused fieldset": {
                            border: "none",
                        },
                        },
                    }}
                    InputProps={{
                        sx: {
                        borderRadius: "10px",
                        "& input::-ms-reveal, & input::-ms-clear": {
                            display: "none",
                        },
                        },
                    }}
                    >
                    {methods.map((m) => (
                        <MenuItem key={m} value={m}>
                        {m}
                        </MenuItem>
                    ))}
                </TextField>
                
                <Divider orientation="vertical" flexItem sx={{ borderWidth: "0 0 0 thin !important", margin: 0, borderColor: "#D9D9D9" }} />

                <TextField
                  fullWidth
                  placeholder="Enter URL or describe the request"
                  variant="outlined"
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                  onPaste={(e) => {
                    const pasted = e.clipboardData.getData("text");
                    if (pasted.trim().startsWith("curl")) {
                      e.preventDefault();
                      const parsed = parseCurl(pasted);
                      console.log(parsed);
                  
                      if (parsed) {
                        setUrl(parsed.url);
                        setMethod(parsed.method);
                        // --- Handle Auth from headers ---
                        let authType = "No Auth";
                        let authValues = {};

                        if (parsed.headers) {
                          const authHeader = parsed.headers.find((h) =>
                            h.toLowerCase().startsWith("authorization:")
                          );

                          if (authHeader) {
                            const value = authHeader.split(":")[1]?.trim() || "";

                            if (value.toLowerCase().startsWith("bearer")) {
                              authType = "bearer";
                              authValues = { token: value.replace(/^Bearer\s+/i, "") };
                            } else if (value.toLowerCase().startsWith("basic")) {
                              authType = "basic";
                              const encoded = value.replace(/^Basic\s+/i, "");
                              try {
                                const decoded = atob(encoded);
                                const [username, password] = decoded.split(":");
                                authValues = { username, password };
                              } catch {
                                authValues = { username: "", password: "" };
                              }
                            }
                          }

                          // API Key check
                          const apiKeyHeader = parsed.headers.find((h) =>
                            h.toLowerCase().startsWith("x-api-key:")
                          );
                          if (apiKeyHeader) {
                            authType = "apikey";
                            authValues = { key: apiKeyHeader.split(":")[1]?.trim() || "" };
                          }
                        }

                        setAuthType(authType);
                        setAuthValue(authValues);

                        // --- Normal headers ---
                        setHeaders([
                          ...(parsed.headers || []).map((h) => {
                            const [key, ...rest] = h.split(":");
                            return { key: key.trim(), value: rest.join(":").trim() };
                          }),
                          { key: "", value: "" },
                        ]);
                  
                        if (parsed.bodyType === "json") {
                          setTabIndex(1);       // show "Body"
                          setBodyTab(0);        // show JSON tab
                          setJsonBody(parsed.body); // fill JSON
                        } else if (parsed.bodyType === "form") {
                          setTabIndex(1);
                          setBodyTab(1);
                          setFormDatas(parsed.form); // set form data
                        }
                      }
                    }
                  }}
                  sx={{
                      borderRadius: "10px",
                      backgroundColor: "#fff",
                      "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                      height: 46,
                      fontSize: "16px",
                      fontWeight: 500,
                      backgroundColor: "#fff",
                      "& fieldset": {
                          border: "none", 
                      },
                      "&:hover fieldset": {
                          border: "none", 
                      },
                      "&.Mui-focused fieldset": {
                          border: "none",
                      },
                      },
                  }}
                  InputProps={{
                      sx: {
                      borderRadius: "10px",
                      "& input::-ms-reveal, & input::-ms-clear": {
                          display: "none",
                      },
                      },
                  }}
                />
            </Box>
          </Box>

          <Tabs value={tabIndex} onChange={(_, newIndex) => setTabIndex(newIndex)}>
              <Tab label="Authorization" />
              <Tab label="Headers" />
              <Tab label="Body" />
          </Tabs>
          <Box>
              {tabIndex === 0 && (
                <Box sx={{ p: 2 }}>
                  <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                    <InputLabel>Auth Type</InputLabel>
                    <Select
                      value={authType}
                      label="Auth Type"
                      onChange={(e) => setAuthType(e.target.value)}
                    >
                      <MenuItem value="noauth">No Auth</MenuItem>
                      <MenuItem value="bearer">Bearer Token</MenuItem>
                      <MenuItem value="basic">Basic Auth</MenuItem>
                      {/* <MenuItem value="apikey">API Key</MenuItem> */}
                    </Select>
                  </FormControl>

                  {authType === "bearer" && (
                    <TextField
                      size="small"
                      label="Bearer Token"
                      fullWidth
                      value={authValue}
                      onChange={(e) => setAuthValue(e.target.value)}
                    />
                  )}

                  {authType === "basic" && (
                    <TextField
                      size="small"
                      label="Username:Password"
                      fullWidth
                      value={authValue}
                      onChange={(e) => setAuthValue(e.target.value)}
                    />
                  )}

                  {authType === "apikey" && (
                    <TextField
                      size="small"
                      label="API Key"
                      fullWidth
                      value={authValue}
                      onChange={(e) => setAuthValue(e.target.value)}
                    />
                  )}
                </Box>
              )}

              {tabIndex === 1 && (
                  <HeaderTable handleHeaderChange={handleHeaderChange} handleDelete={handleDelete} headers={headers} />                                         
              )}
              {tabIndex === 2 && (
                <>
                  <RadioGroup row value={bodyTab.toString()} onChange={(e) => setBodyTab(Number(e.target.value))} sx={{ mb: 0.5, px: 2 }}>
                    <FormControlLabel value="0" control={<Radio size="small" />} label="JSON" sx={{ mr: 2, cursor: "pointer", fontWeight: bodyTab === 0 ? 600 : 400, '& .MuiFormControlLabel-label': { color: bodyTab === 0 ? "#185CB7" : "#6F6F6F", fontSize: 14 }, }} />
                    <FormControlLabel value="1" control={<Radio size="small" />} label="Form Data" sx={{ mr: 2, cursor: "pointer", fontWeight: bodyTab === 1 ? 600 : 400, '& .MuiFormControlLabel-label': { color: bodyTab === 1 ? "#185CB7" : "#6F6F6F", fontSize: 14 }, }} />
                  </RadioGroup>

                  {bodyTab === 0 && (
                    <TextField
                      fullWidth
                      multiline
                      minRows={6}
                      placeholder="{}"
                      value={jsonBody}
                      onChange={(e) => setJsonBody(e.target.value)}
                    />
                  )}
              
                  {bodyTab === 1 && (
                    <ApiBodyTable handleFormDataChange={handleFormDataChange} handleFormDataDelete={handleFormDataDelete} formDatas={formDatas} />
                  )}
                </>
              )}
          </Box>

          <Button variant="contained" sx={{ minWidth: '207px', height: 40, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", "&:disabled": {background: "#E4E4E4", color: "#ffffff", borderColor: "#E4E4E4"}, "&:hover": {background: "#185CB7", color: "#ffffff", borderColor: "#185CB7"}, mt: 2 }} onClick={() => setOpenResponses(true)}>
              + Add Responses ({apiResponses.length})
          </Button>
          {apiResponses.length > 0 && (
            <Box mt={2}>
                <Typography>Added Responses</Typography>
                {apiResponses.map((res, index) => (
                  <Box key={index} display="flex" alignItems="center" gap={1} mb={1} ml={2}>
                    <Typography>{index + 1}. {res.name}</Typography>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setSelectedResponse(res);
                        setOpenResponses(true);
                      }}
                    >
                      {allIcons.eyeBlueIcon}
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => {
                        const updated = apiResponses.filter((_, i) => i !== index);
                        setApiResponses(updated);
                      }}
                    >
                      {allIcons.deleteIconRed}
                    </IconButton>
                  </Box>
                ))}
            </Box>
          )}
          <Box mt={2}>
            <Typography mb={1}>Documentation</Typography>
            <GlobalStyles styles={{
                '.tox-promotion': { display: 'none !important' },
                '.tox-statusbar__branding': { display: 'none !important' },
                '.tox-tinymce': { border: '1px solid #DFDFDF !important' },
            }} />
            <Editor
              apiKey='ejfq37hgybsrwmucu0b2ec7eswr1e3r0t85x0tze0snanjkq'
              value={body || "Endpoint Documentation"}
              onEditorChange={(newValue) => setBody(newValue)}
              init={{
                theme: "silver",
                branding: false,
                promotion: false, 
                plugins: [
                  'anchor', 'autolink', 'charmap', 'codesample', 'emoticons', 'image', 'link',
                  'lists', 'media', 'searchreplace', 'table', 'visualblocks', 'wordcount', "code",
                ],
                toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link table code | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
                tinycomments_mode: 'embedded',
                tinycomments_author: 'Author name',
                valid_elements: '*[*]',
                valid_styles: {
                  '*': 'color,font-size,font-weight,font-style,text-decoration,float,' +
                      'margin,margin-top,margin-right,margin-bottom,margin-left,' +
                      'padding,padding-top,padding-right,padding-bottom,padding-left,' +
                      'background,background-color'
                },
                paste_data_images: true,
                paste_retain_style_properties: "all",
                fullpage_default_doctype: '<!DOCTYPE html>',
                fullpage: true,
                importcss_append: true,
                content_css: false,
                relative_urls: false,
                remove_script_host: false,
                convert_urls: false,
                extended_valid_elements: 'style[type|media]',
                valid_children: '+head[style],+body[style]',
                paste_webkit_styles: "all",
                paste_data_images: true,
                paste_preprocess: (plugin, args) => {
                  // ✅ optional: force keeping <style> tag if not working
                  args.content = args.content.replace(/<style[^>]*>/g, '<style>').replace(/<\/style>/g, '</style>');
                },
              }}
            />
          </Box>
        </Box>

        <Divider mt="10px" />

        <Box display="flex" justifyContent="end" alignItems="center" p="20px 30px" gap="15px">
            <Button variant="contained" sx={{ width: '171px', height: 46, color: "#1D1D1D", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #D2D2D2", boxShadow: "none", fontWeight: "500",}}  onClick={handleClose} >
                Cancel
            </Button>
            <Button variant="contained" sx={{ width: '171px', height: 46, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", "&:disabled": {background: "#E4E4E4", color: "#ffffff", borderColor: "#E4E4E4"}, "&:hover": {background: "#185CB7", color: "#ffffff", borderColor: "#185CB7"} }} onClick={handleSave} >
                Save
            </Button>
        </Box>
      </Box>
    </Box>
    {openResponses && <AddResponses apiResponses={apiResponses} setApiResponses={setApiResponses} openResponses={openResponses} setOpenResponses={setOpenResponses} handleResponseClose={() => setOpenResponses(false)} selectedResponse={selectedResponse} />}
  </>);
};

export default AddEndpoint;
